import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffScheduleRequestsPending extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      staff_schedule_request_id: null,
      manager_answer_reason: null,
      modal: false,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.approve = this.approve.bind(this);
    this.reprove = this.reprove.bind(this);
    this.reproveModal = this.reproveModal.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }


  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/geral/escala/solicitacoes/pendentes', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-success" value={cell} onClick={() => this.approve(cell)}>
          <i className="fa fa-fw fa-check"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={() => this.reproveModal(cell)}>
          <i className="fa fa-fw fa-close"></i>
        </button>
      </div>
    );

    return botao;
  }

  reproveModal (staff_schedule_request_id) {
    var confirm = window.confirm(this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.reprovar);
    if (confirm) {
        this.setState({staff_schedule_request_id: staff_schedule_request_id, modal: true, manager_answer_reason: null});
    }
  }

  reprove (event) {
    event.preventDefault();

    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var datasave = {
        id: this.state.staff_schedule_request_id,
        manager_answer_reason: this.state.manager_answer_reason,
    };

    Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/reprovacao/gestor/alteracao/escala', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
                self.setState({data: responseJson.data});
                self.setState({staff_schedule_request_id: null, modal: false, manager_answer_reason: null});
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
            console.error(error);
        });
    });
  }

  approve (staff_schedule_request_id) {
    var confirm = window.confirm(this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.aprovar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: staff_schedule_request_id,
      };

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aprovacao/gestor/alteracao/escala', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.titulo}</h3>
      <hr/>
        <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.semSolicitacoes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.Acoes}</TableHeaderColumn>
            <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.ID}</TableHeaderColumn>
            <TableHeaderColumn dataField="creation_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.DataDeCriacao}</TableHeaderColumn>
            <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='300'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.NomeDoColaborador}</TableHeaderColumn>
            <TableHeaderColumn dataField="start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.Inicio}</TableHeaderColumn>
            <TableHeaderColumn dataField="finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.Fim}</TableHeaderColumn>
            <TableHeaderColumn dataField="reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='500'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.Justificativa}</TableHeaderColumn>
            <TableHeaderColumn dataField="fleet_chief_answer_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.ChefeDeFrotaDataResposta}</TableHeaderColumn>
            <TableHeaderColumn dataField="fleet_chief_answer_reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='500'>{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tabela.ChefeDeFrotaJustificativa}</TableHeaderColumn>

        </BootstrapTable>
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'medium'}>
        <Modal.Header>
          <h4 className="pull-left">{this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.tituloJustifiqueAReprovacao}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ staff_schedule_request_id: null, modal: false, manager_answer_reason: null })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.reprove}>
            <div className="form-group">
              <textarea style={{ height: 150 }} type="text" name="manager_answer_reason" className="form-control" value={this.state.manager_answer_reason} onChange={this.handleChange.bind(this, 'manager_answer_reason')} required />
            </div>
            <div className="form-group">
              <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Solicitacoes.ListaDeSolicitacoesPendentes.formulario.botaoJustificar}</button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ staff_schedule_request_id: null, modal: false, manager_answer_reason: null })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default StaffScheduleRequestsPending;



// WEBPACK FOOTER //
// ./src/Components/StaffScheduleRequests/StaffScheduleRequestsPending.js